export default __webpack_public_path__ + "static/media/hero-3-bg.d97bc2d2.png";